import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { PRODUCT_SALES } from '../../constants';
import { ProductSalesQuery } from '../queries';

export class ProductSalesCalculator extends Calculator {
  kpiType = PRODUCT_SALES

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(ProductSalesQuery, this.currentPeriod);
    const props = this.getDataIfNoPreviousPeriod(currentResponse.data.result);
    return this.getModelToInstance(props);
  }

  getDataIfNoPreviousPeriod(currentResponse) {
    return {
      key: `${this.pointOfSaleGuid}-${this.isManaged}`,
      kpi: currentResponse,
      increment: null,
      type: this.kpiType,
    };
  }
}
